import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environment';
import { UserAction } from '@longnecktech/splash-commons-fe';

@Injectable({
  providedIn: 'root',
})
export class UserActionService {
  private http = inject(HttpClient);

  constructor() {}

  sendAction(
    action: UserAction,
    metadata: unknown,
    userUuid?: string,
  ): Observable<void> {
    return this.http.post<void>(
      environment.backendUrl + `/api/public/backoffice-auth/action`,
      {
        action,
        metadata,
        gameUuid: null,
        userUuid,
      },
    );
  }
}
